export default {
  "path": "/demo/businessYouthMap",
  "meta": {
    "name": "demo-青春版选址地图组件Demo",
    "title": "青春版选址地图组件Demo",
    "isComponentDoc": true,
    "category": "Business"
  }
};